import React from "react";
import "./ContactDetails.css";
import MapImg from "../../images/map.png";

export default function ContactDetails() {
  return (
    <div className="contact-info-card">
      <h3>Prefer to Connect Directly?</h3>
      <p className="info-subtitle">Multiple ways to reach us</p>

      <div className="contact-methods">
        <div className="info-row">
          <span className="icon">📧</span>
          <div className="info-content">
            <p className="info-label">Email</p>
            <p className="info-value">risenstargoods@gmail.com</p>
          </div>
        </div>

        <div className="info-row">
          <span className="icon">📞</span>
          <div className="info-content">
            <p className="info-label">Primary Contact Numbers</p>
            <p className="info-value">UAE (+971 56 654 1871)</p>
            <p className="info-value">PAK (+92 305 580 8021)</p>
            <p className="info-value">ID (+62 813 103 9104)</p>
          </div>
        </div>

        <div className="info-row">
          <span className="icon">💬</span>
          <div className="info-content">
            <p className="info-label">WhatsApp</p>
            <p className="info-value">+971 56 654 1871</p>
          </div>
        </div>
      </div>

      <div className="location-section">
        <h4>📍 Headquarters: UAE</h4>
        <p className="location-desc">
          Strategic location for global operations
        </p>
        <img src={MapImg} alt="UAE location map" className="map-img" />
      </div>
    </div>
  );
}
